import { useState, useEffect } from "react";

const useClientAdmin = () => {  
  const [isClientAdmin, setIsClientAdmin] = useState(false);
    const [clientId, setClientId] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem("userDetails");
    if (userData) {
      try {
        const parsedData = JSON.parse(userData);
        setIsClientAdmin(parsedData?.is_client_admin ?? false);
         setClientId(parsedData?.client?.id ?? null);
      } catch (error) {
        console.error("Error parsing userDetails:", error);
      }
    }
  }, []);

  return { isClientAdmin, clientId };
};

export default useClientAdmin;  
